const GET_ENTRIES = 'plan//GET_ENTRIES'
const GET_ENTRY = 'plan//GET_ENTRY'
const SET_PLAN = 'plan//SET_PLAN'
const REMOVE_PLAN = 'plan//REMOVE_PLAN'

export {
  GET_ENTRIES,
  GET_ENTRY,
  SET_PLAN,
  REMOVE_PLAN
}
